export const getImageUrl = (imageUrl: string | undefined): string => {
  if (!imageUrl) {
    return 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjZjNmNGY2Ii8+CiAgPHRleHQgeD0iNTAlIiB5PSI1MCUiIGRvbWluYW50LWJhc2VsaW5lPSJtaWRkbGUiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IiM5Y2EzYWYiIGZvbnQtZmFtaWx5PSJtb25vc3BhY2UiIGZvbnQtc2l6ZT0iMTNweCI+Tm8gSW1hZ2U8L3RleHQ+Cjwvc3ZnPg==';
  }
  
  // If it's already a full URL, return as is
  if (imageUrl.startsWith('https://') || imageUrl.startsWith('http://')) {
    return imageUrl;
  }
  
  // If it starts with /api/, return it as is (it's a server endpoint)
  if (imageUrl.startsWith('/api/')) {
    return imageUrl;
  }
  
  // If it starts with /uploads/, return it as is (it's a static file served from same origin)
  if (imageUrl.startsWith('/uploads/')) {
    return imageUrl;
  }
  
  // Otherwise, prepend the API base URL from environment variables
  const baseUrl = 'https://localhost:7000';
  const finalUrl = `${baseUrl}${imageUrl}`;
  return finalUrl;
}; 